import { afterEvent, defineGameCard, onAppear } from '../authoring/index.js';
import { isSlimeUnit, SLIME_RESIDUE_ID, slimeSetDependencies, tableOf, trail, } from './slime-helpers.js';
const APPEARED_KEY = '@cards/ability/blind_amoeba/appeared/ready';
export const BlindAmoebaCard = defineGameCard({
    id: 'blind_amoeba',
    gameplay: { type: 'UNIT', cost: 4, baseStats: { attack: 3, health: 3 }, traits: ['SLIME'] },
    presentation: {
        name: 'Слепая амёба',
        description: 'След 1. Первый раз за раунд поглощает первого другого слизня, разыгранного в эту локацию.',
        glyph: {
            colors: ['#10213A', '#339F94', '#2A7A7F', '#2A7A7F', '#2A7A7F'],
            rows: [
                '....................',
                '....................',
                '.......111111.......',
                '......12222221......',
                '.....1223223221.....',
                '....122222222221....',
                '...1222233333221....',
                '...12223.....3221...',
                '..13223.......321...',
                '..13223.......321...',
                '..13223.......321...',
                '.132223.......321...',
                '.1322223.....3221...',
                '.1222222333332221...',
                '.1222222222222231...',
                '.1223333322223331...',
                '..13331111133311....',
                '...111.....111......',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeSetDependencies(SLIME_RESIDUE_ID),
    abilities: [
        trail(),
        // All planned FIELD cards are materialized before their individual
        // appearances resolve. Do not let this card observe an earlier slime from
        // that batch merely because it has already been placed on the board.
        onAppear((ctx) => {
            const self = ctx.self;
            if (self !== undefined)
                ctx.ops.setVar(APPEARED_KEY, true);
        }, { cause: 'played' }),
        afterEvent({
            abilityId: 'first_played_slime',
            event: 'UnitAppeared',
            frequency: 'first_per_round',
            when: (ctx, event) => {
                const self = ctx.self;
                const candidate = ctx.q.instance(event.instanceId);
                return self?.cellId !== undefined
                    // Existing cards entered on an earlier round are already active;
                    // a current-round card activates only after its own onAppear hook.
                    && (self.enteredRound !== ctx.round || self.vars[APPEARED_KEY] === true)
                    && candidate?.cellId !== undefined
                    && event.cause === 'played'
                    && candidate.id !== self.id
                    && tableOf(candidate.cellId) === tableOf(self.cellId)
                    && isSlimeUnit(candidate);
            },
            run: (ctx, event) => {
                if (ctx.self !== undefined)
                    ctx.ops.absorbCards(ctx.self.id, [event.instanceId]);
            },
        }),
    ],
    ui: { mechanics: ['trail', 'slime_residue', 'absorb'] },
});
//# sourceMappingURL=blind_amoeba.js.map